import { useAuth } from '@/hooks/useAuth';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';

export function ProfileTab() {
  const { user, profile } = useAuth();

  return (
    <div className="space-y-6">
      <div className="space-y-2">
        <Label htmlFor="email">Correo electrónico</Label>
        <Input 
          id="email" 
          type="email" 
          value={user?.email || ''} 
          disabled 
          className="bg-muted"
        />
        <p className="text-xs text-muted-foreground">
          El correo electrónico no se puede modificar
        </p>
      </div>

      <div className="space-y-2">
        <Label htmlFor="name">Nombre completo</Label>
        <Input 
          id="name" 
          type="text" 
          value={profile?.full_name || ''} 
          disabled
          className="bg-muted"
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="municipality">Municipio</Label>
        <Input 
          id="municipality" 
          type="text" 
          value={profile?.municipality_name || ''} 
          disabled
          className="bg-muted"
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="role">Rol</Label>
        <Input 
          id="role" 
          type="text" 
          value={profile?.role || ''} 
          disabled
          className="bg-muted capitalize"
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="plan">Plan actual</Label>
        <Input 
          id="plan" 
          type="text" 
          value={profile?.plan || 'free'} 
          disabled
          className="bg-muted capitalize"
        />
      </div>
    </div>
  );
}
